import { createFileRoute } from "@tanstack/react-router";
import { CategoriesContainer } from "@/features/categories";
import { categoriesQueryOptions } from "@/features/categories/hooks/use-categories";
import { resolveStoreId } from "@/lib/store-loader";

export const Route = createFileRoute("/$store/_layout/categories")({
	loader: async ({ context, params }) => {
		const storeId = await resolveStoreId(context.queryClient, params.store);
		if (!storeId) return;
		await context.queryClient.ensureQueryData(
			categoriesQueryOptions(params.store, storeId),
		);
	},
	component: CategoriesPage,
});

function CategoriesPage() {
	return <CategoriesContainer />;
}
